import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { IState } from '../../../store';
import { ComplaintButton, IComplaintButtonProps } from './index';
import { EFeedbackComplaint, statusChanger } from '../../../store/complaint/feedback_complaint';
import { setComplaintPopupOpenValue } from '../../../store/complaintPopupOpen';

type TStoreProps = Pick<IComplaintButtonProps, 'agent' | 'offer' | 'complaintPopupOpen'>;
type TDispatchProps = Pick<IComplaintButtonProps, 'complaintFeedbackFormStatus' | 'togglePopup'>;
type TOwnProps = Pick<IComplaintButtonProps, 'className'>;

export function mapStateToProps(state: IState): TStoreProps {
  return {
    agent: state.offerData.agent,
    offer: state.offerData.offer,
    complaintPopupOpen: state.complaintPopupOpen,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): TDispatchProps {
  return {
    complaintFeedbackFormStatus: (status: EFeedbackComplaint) => dispatch(statusChanger(status)),
    togglePopup: (value: boolean) => dispatch(setComplaintPopupOpenValue(value)),
  };
}

export const ComplaintButtonContainer = connect<TStoreProps, TDispatchProps, TOwnProps>(
  mapStateToProps,
  mapDispatchToProps,
)(ComplaintButton);
